<div class="card title-card mb-4">
  <div class="flex align-items-center">
    <i class="pi mr-1 title-card-icon" [class.pi-plus-circle]="mode === 'create'" [class.pi-pencil]="mode === 'edit'"></i>
    <p class="mb-0 text-3xl title">
      {{(mode == 'create' ? 'misc.creation.decoder' : 'misc.edition.decoder') | transloco | capitalize}}
    </p>
  </div>
</div>
<div class="card step-card flex flex-column">
  <form [formGroup]="decoderForm" *ngIf="decoderForm">
    <div class="grid">

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="name">{{'attribute.name' | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <input pInputText id="name" type="text" formControlName="name" class="w-full">
        </div>
        <app-validation-errors [control]="decoderForm.get('name')"></app-validation-errors>
      </div>

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="type">{{'attribute.type' | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <p-dropdown
            [placeholder]="'select.type' | transloco"
            [options]="types"
            (onChange)="typeChanged($event)"
            styleClass="w-full"
            id="type"
            formControlName="type"
          ></p-dropdown>
        </div>
        <app-validation-errors [control]="decoderForm.get('type')"></app-validation-errors>
      </div>

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="routingKey">{{'attribute.routingKey' | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <input pInputText id="routingKey" type="text" formControlName="routingKey" class="w-full">
        </div>
        <app-validation-errors [control]="decoderForm.get('routingKey')"></app-validation-errors>
      </div>

      <div class="col-12 md:col-12 lg:col-6 xl:col-4" [hidden]="!sourceVisible">
        <div class="form-field col-12">
          <label for="source">{{'attribute.source' | transloco}}</label>
        </div>
        <div class="col-12">
          <textarea pInputText id="source" formControlName="source" class="w-full"></textarea>
        </div>
      </div>

    </div>
  </form>
  <div class="mt-auto">
    <div class="flex justify-content-between mt-4">
      <button
        [label]="'common.cancel' | transloco"
        (click)="cancel()"
        pButton
        class="p-button-danger ml-2"
        iconPos="right"
      ></button>
      <p-button
        *ngIf="decoderForm"
        [label]="(mode == 'creation' ? 'common.create' : 'common.save') | transloco"
        [disabled]="!decoderForm.valid"
        [loading]="persistingChanges"
        (onClick)="persistDefaultDecoderData()"
        styleClass="p-button-primary"
        class="mr-2"
      ></p-button>
    </div>
  </div>
</div>
